import { render, staticRenderFns } from "./UIFloatingActionButton.vue?vue&type=template&id=4b24c6f0&scoped=true&"
import script from "./UIFloatingActionButton.vue?vue&type=script&lang=js&"
export * from "./UIFloatingActionButton.vue?vue&type=script&lang=js&"
import style0 from "./UIFloatingActionButton.vue?vue&type=style&index=0&id=4b24c6f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b24c6f0",
  null
  
)

export default component.exports